<script>
    import { onMount } from "svelte";

    export let customContainerStyle = "";
    export let customContainerClass = "";

    let containerRef;
    let tdHeight = 0;

    onMount(() => {
        if (containerRef) {
            const parent = containerRef.parentElement;
            if (parent) tdHeight = parent.offsetHeight;
        }
    });
</script>

<div class="flex h-full items-center justify-center" bind:this={containerRef}>
    <div
        class={`flex items-center justify-center w-full pl-4 box-border	 ${customContainerClass}`}
        style={`${customContainerStyle}; ${tdHeight ? `height: ${tdHeight}px; ` : ""}`}
    >
        <slot />
    </div>
</div>
